import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const sourceService = {
    getAllSources,
    updateSourceStatus,
    getSource,
    updateSource,
    createSource,
};

const MODULE = {
    SOURCE: 'rnd-sources',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'Source') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllSources(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            name: filter.name,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.SOURCE}`, requestOptions)
}


export function updateSourceStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.SOURCE}/${data.id}`, requestOptions)
}

export async function getSource(id) {
    return await apiHelper(API_URL).get(`/${MODULE.SOURCE}/${id}`)
}

export function updateSource(data) {
    const requestOptions = {
        name: data.name,
    }
    return apiHelper(API_URL).put(`/${MODULE.SOURCE}/${data.id}`, requestOptions)
}

export function createSource(data) {
    const requestOptions = {
        name: data.name,
    }

    return apiHelper(API_URL).post(`/${MODULE.SOURCE}`, requestOptions)
}